import { Form, Link, redirect } from "react-router-dom";
import "./CostumerCreate.scss";
import { useState } from "react";
import DatePicker from "react-datepicker";
import APIModel from "../../APIModel";
import store from "../../store/store";

export async function action({ request, params }) {
  const formRequest = await request.formData();
  const token = store.getState().auth.token;

  const responce = await APIModel.createCostumer(
    token,
    formRequest.get("firstname"),
    formRequest.get("lastname"),
    formRequest.get("date"),
    formRequest.get("comment")
  );
  return redirect("/");
}

export default function CostumerCreate() {
  const [date, setDate] = useState(new Date());

  return (
    <div className="create-costumer">
      <Link to="..">back</Link>
      <Form method="post" id="create-costumer">
        <div className="create-costumer__input">
          First name: <input name="firstname" required />
        </div>
        <div className="create-costumer__input">
          Last name: <input name="lastname" required />
        </div>
        <div className="create-costumer__input">
          date expressedIn{" "}
          <DatePicker
            className="costumer__datepicker"
            dateFormat="yyyy-MM-dd"
            selected={date}
            onChange={(date) => setDate(date)}
            required
            name="date"
          />
        </div>
        <div className="create-costumer__textarea">
          <textarea name="comment"></textarea>
        </div>
        <button type="sumbit">sumbit</button>
      </Form>
    </div>
  );
}
